import React from "react";
import ServiceImg1 from "../Assets/Images/svg-icons/1.svg";
import ServiceImg2 from "../Assets/Images/svg-icons/2.svg";
import ServiceImg3 from "../Assets/Images/svg-icons/3.svg";
import ServiceImg4 from "../Assets/Images/svg-icons/4.svg";

const services = [
  {
    img: ServiceImg1,
    title: "Consultation",
    description: "At FusionHub, our consultation services provide expert guidance, actionable insights, and tailored solutions to help businesses overcome challenges and drive measurable results."
  },
  {
    img: ServiceImg2,
    title: "Digital / IT Services",
    description: "We provide end-to-end IT and digital solutions — from custom software and web development to cloud, cybersecurity, and automation. Our goal is to help businesses innovate, scale, and stay secure in a digital-first world."
  },
  {
    img: ServiceImg3,
    title: "Engineering Solutions",
    description: "We provide efficient, innovative engineering solutions across multiple sectors, ensuring quality, safety, and compliance tailored to our clients' technical needs."
  },
  {
    img: ServiceImg4,
    title: "Designing",
    description: "Specializing in solar power systems and energy efficient lighting, FusionHub helps residential, commercial, and industrial clients reduce costs and improve sustainability."
  }
];


const WhatWeDo = () => {
  return (
    <div className="sbst-service-area pd-default-120" id="what-we-do">
      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-10">
            <div className="section-title text-center">
              <h2 className="title wow fadeInUp animated" data-wow-duration="0.6s" data-wow-delay="0.1s">
                What We <span>Do?</span>
              </h2>
              <p className="wow fadeInUp animated text-center" data-wow-duration="0.6s" data-wow-delay="0.2s">
                Delivering Smart, Scalable, and Tailored Solutions Across Engineering, IT, and Digital Domains
              </p>
            </div>
          </div>
        </div>

        {/* Service Cards */}
        <div className="row custom-gutters-28 justify-content-center">
          {services.map((service, index) => (
            <div className="col-lg-3 col-sm-6" key={index}>
              <div className={`single-service-2 text-center wow fadeInUp animated`} data-wow-duration="0.6s" data-wow-delay={`${0.2 * index + 0.1}s`}>
                <div className="thumb">
                  <img src={service.img} alt="service" />
                </div>
                <h6>{service.title}</h6>
                <p className="text-center">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
